import { createApp } from 'vue';
import ImageGallery from '@lmt-rpb/ImageGallery/ImageGallery.vue';
import { mountReplace } from '../utils/mountUtils';
import { determinePageType } from '../utils/utils';

const mountPoint = document.getElementById('hotel-gallery-button');

function initGalleryButton() {
	const dataset = document.getElementById('hotel-gallery')?.dataset;
	const hotelName = document.querySelector('.hotel-info__header > h1')?.textContent;
	const app = createApp(ImageGallery, {
		images: JSON.parse(dataset?.images ?? '[]'),
		hotelName: hotelName,
	});

	if (mountPoint) mountReplace(app, mountPoint);
}

const pageType = determinePageType();

if (pageType === 'hotelPage' && mountPoint) {
	initGalleryButton();
}
